import { postDataAPI } from "../../utils/fetchData"



export const TYPES = {
  URL_REQUEST_LOADING: "URL_REQUEST_LOADING",
  URL_REQUEST_SUCCESS: "URL_REQUEST_SUCCESS",
  URL_REQUEST_ERROR: "URL_REQUEST_ERROR",
  URL_EXIT: "URL_EXIT",
};


export const getAllUrls = (dataFilter) => async (dispatch) => {
  try {
    dispatch({
      type: TYPES.URL_REQUEST_LOADING,
    });

    const res = await postDataAPI("urlsRed/all", dataFilter);
    if (res) {
      dispatch({
        type: TYPES.URL_REQUEST_SUCCESS,
        payload: { data: res.data?.data },
      });
    }
  } catch (error) {
    dispatch({
      type: TYPES.URL_REQUEST_ERROR,
      payload: error.response?.message || error.response?.data?.msg,
    });
  }
};
